import { satisfies as versionSatisfies, coerce as semverCoerce } from "semver";
const deviceVersionRangesForHardwareVersion = {
    nanoX: ">=2.0.0",
};
/**
 * @returns whether the Hardware Version bytes are included in the result of the
 * getVersion APDU
 * */
export const isHardwareVersionSupported = (seVersion, modelId) => !!modelId &&
    !!deviceVersionRangesForHardwareVersion[modelId] &&
    !!versionSatisfies(semverCoerce(seVersion) || seVersion, deviceVersionRangesForHardwareVersion[modelId]);
//# sourceMappingURL=isHardwareVersionSupported.js.map